import { Card, CardContent, CardHeader, CardTitle } from '../../../../components/ui/molecules/card';
import { InfoTip } from '../../../../components/ui/atoms/info-tip';
import { summaryCards } from '../utils';
import { SummaryCardsProps } from '../interface';

export function SummaryCards({ data, isLoading, isError }: SummaryCardsProps) {
  if (isError) {
    return <p className="text-sm text-destructive">Couldn't load the KPI summary. Try changing a filter or reloading.</p>;
  }

  if (isLoading || !data) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4" aria-busy="true">
        {Array.from({ length: 5 }, (_, i) => (
          <div key={i} className="h-24 animate-pulse rounded-lg border bg-muted/40" />
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
      {summaryCards(data.summary).map((c) => (
        <Card key={c.key}>
          <CardHeader className="pb-1">
            <CardTitle className="flex items-center gap-1.5 text-sm font-medium text-muted-foreground">
              {c.title}
              <InfoTip text={c.formula} label={`${c.title} formula`} />
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-2xl font-bold">{c.value}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
